import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";

/* Pages */
import Home from "./Pages/Home.js";
import About from "./Pages/About.js";
import Products from "./Pages/ProductsPage/Products.js";
import ProductDetails from "./Pages/ProductsPage/ProductDetails.js";
import Testimonials from "./Pages/TestimonialsPage/Testimonials.js";
import Contact from "./Pages/Contact.js";

import Blog from "./Pages/Blog/Blog.js";
import Events from "./Pages/Events/Events.js";
import News from "./Pages/News/News.js";
import PhotoGallery from "./Pages/PhotoGallery/PhotoGallery.js";
import VideoGallery from "./Pages/VideoGallery/VideoGallery.js";
import ProductCatalog from "./Pages/ProductCatalog/ProductCatalog.js";

import ScrollToTop from "./Components/ScrollToTop";

/* Layout */
import Navigation from "./Pages/Navigation.js";
import Footer from "./Pages/Footer.js";
import ModernLayout from "./Components/modern/ModernLayout";

function App() {
  const path = useLocation().pathname.replace(/\/$/, "") || "/";
  const isModern = [
    "/",
    "/about",
    "/testimonials",
    "/products",
    "/photo-gallery",
    "/video-gallery",
    "/news",
    "/events",
    "/product-catalog",
    "/blog",
    "/contact",
  ].includes(path) || path.startsWith("/products/");
  return (
    <div className="App">

      {/* AUTO SCROLL TO TOP ON PAGE CHANGE */}
      <ScrollToTop />

      {!isModern && <Navigation />}

      <Routes>
        <Route element={<ModernLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:productId" element={<ProductDetails />} />
          <Route path="/photo-gallery" element={<PhotoGallery />} />
          <Route path="/video-gallery" element={<VideoGallery />} />
          <Route path="/news" element={<News />} />
          <Route path="/events" element={<Events />} />
          <Route path="/product-catalog" element={<ProductCatalog />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>

      {!isModern && <Footer />}

    </div>
  );
}

export default App;
